// Keep this codec identical to common/external_references.py. Pool keys are
// full references; literal Sheet resolves against the current unit's metadata.

function escapeComponent(value) {
  if (typeof value !== 'string' || !value) throw new Error('External reference names and labels must be nonempty strings.');
  return value.replace(/%/g, '%25').replace(/>/g, '%3E').replace(/`/g, '%60');
}

export function externalReference(scope, key, { namedSheet = false } = {}) {
  let encodedScope = escapeComponent(scope);
  if (namedSheet && ['Sheet', 'Doc'].includes(scope)) {
    encodedScope = `%${scope.charCodeAt(0).toString(16).toUpperCase()}${encodedScope.slice(1)}`;
  }
  return `External >> ${encodedScope} >> ${escapeComponent(key)}`;
}

export function parseExternalReference(reference) {
  const parts = reference.split(' >> ');
  if (parts.length !== 3 || parts[0] !== 'External') throw new Error(`Invalid external reference: ${reference}`);
  const scope = parts[1];
  const sourceName = decodeURIComponent(scope);
  const key = decodeURIComponent(parts[2]);
  const expected = externalReference(sourceName, key, { namedSheet: !['Sheet', 'Doc'].includes(scope) });
  if (expected !== reference) throw new Error(`Invalid escaping in external reference: ${reference}`);
  return { scope, sourceName, key };
}

export function displayExternalReference(reference, separator = ' >> ') {
  const { scope, sourceName, key } = parseExternalReference(reference);
  const label = scope !== sourceName && ['Sheet', 'Doc'].includes(sourceName)
    ? `Worksheet "${sourceName}"` : sourceName;
  return ['External', label, key].join(separator);
}
